<template lang="pug">
v-card.elevation-1
  .d-flex
    .flex-1
      v-card-title.pa-2.pl-4.font-size-16
        span.font-weight-700 Tickets abiertos de
        span.font-weight-700.primary--text  &nbsp;{{tipo.toLowerCase()}}&nbsp;
        span.font-weight-700  por estado
      v-card-subtitle.pb-3.font-size-12.grey--text Listado general de tickets
    v-btn.ma-2( color="info"  small  @click="reRenderChart()")
      v-icon sync
      | Actualizar
  .d-flex.fd-column
    .d-flex.mb-4.ml-4
      .d-flex
        v-select(v-model='tiempo' solo :items="tiempos" item-text="name" item-value="id" :disabled="isLoading"   label='Tiempo'  dense hide-details @change="getDatesForChart()")
        .flex-1.d-flex
          .ml-4
            v-text-field(label='Desde' v-model="desde" solo dense type="date"  hide-details )
          .ml-4
            v-text-field(label='Hasta' v-model="hasta" solo dense type="date" hide-details)
    LineChart(
      v-if="renderChart"
      :tipo="tipo"
      :desde="desde"
      :hasta="hasta"
      ref="lineChart"
    )
</template>
<script>
import LineChart from '@/components/c_chart_line_cantidad_tickets_abiertos_por_estado'
import moment from 'moment';
import { notify } from '../util/general';
export default {
  name: 'c_card_chart_line_cantidad_total_tickets_por_estados',
  components : {
    LineChart
  },
  props: {
    tipo : {
      type   : String,
      default: 'garantia'
    }
  },
  data () {
    return {
      isLoading              : false,
      renderChart            : false,
      lista : [],
      tiempos : [
        {
          id : 1,
          name : 'Hoy',
          desde : moment().format('YYYY-MM-DD'),
          hasta : moment().format('YYYY-MM-DD')
        },
        {
          id : 2,
          name : 'Hace una semana',
          desde : moment().subtract(7, 'day').format('YYYY-MM-DD'),
          hasta : moment().format('YYYY-MM-DD')
        },
        {
          id : 3,
          name : 'Hace un mes',
          desde : moment().subtract(1, 'month').format('YYYY-MM-DD'),
          hasta : moment().format('YYYY-MM-DD')
        },
        {
          id : 4,
          name : 'Hace 6 meses',
          desde : moment().subtract(6, 'month').format('YYYY-MM-DD'),
          hasta : moment().format('YYYY-MM-DD')
        },
        {
          id : 5,
          name : 'Hace 1 año',
          desde : moment().subtract(1, 'year').format('YYYY-MM-DD'),
          hasta : moment().format('YYYY-MM-DD')
        },
        {
          id : 6,
          name : 'Personalizado'
        }
      ],
      tiempo : 3,
      desde : moment().subtract(1, 'month').format('YYYY-MM-DD'),
      hasta : moment().format('YYYY-MM-DD')
    }
  },
  mounted () {
    var vm = this;
    vm.reRenderChart()
  },
  methods : {
    reRenderChart () {
      var vm = this
      if (!vm.desde || !vm.hasta) {
        return notify(vm, 'error', 'Error', 'Alguna de las fechas no son validas')
      }
      vm.renderChart = false
      vm.$nextTick(() => {
        vm.renderChart = true
      })
    },
    getDatesForChart () {
      var vm = this
      if (vm.tiempo !== 6) {
        var { desde, hasta } = vm.tiempos.find(e => e.id === vm.tiempo)
        vm.desde = desde
        vm.hasta = hasta
        vm.reRenderChart()
      } else {
        vm.desde = ''
        vm.hasta = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// c_card_chart_line_cantidad_total_tickets_por_estados.vue?43d6ae66